/* Small enhancements around Dawn's native gallery, product form and filters. */
(() => {
  function tabs(root, panelSelector) {
    if (root.dataset.vrReady) return;
    root.dataset.vrReady = 'true';
    const buttons = [...root.querySelectorAll('[role="tab"]')];
    function select(button) {
      buttons.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      root.querySelectorAll(panelSelector).forEach(panel => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(button));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { event.preventDefault(); select(buttons[next]); buttons[next].focus(); }
      });
    });
  }
  function purchase(root) {
    const info = root.querySelector('.product__info-container');
    if (!info || info.querySelector('.vr-purchase-row')) return;
    const qty = info.querySelector('.product-form__quantity');
    const form = info.querySelector('product-form');
    if (!qty || !form) return;
    const wrapper = form.parentElement;
    const row = document.createElement('div'); row.className = 'vr-purchase-row';
    wrapper.before(row); wrapper.classList.add('vr-buy-wrapper'); row.append(qty, wrapper);
    const pickup = wrapper.querySelector('pickup-availability');
    const quote = document.createElement('p'); quote.className = 'vr-quote';
    quote.textContent = document.documentElement.lang.startsWith('it') ? 'Quotazione al check-out' : 'Shipping quote at checkout';
    row.after(quote); if (pickup) quote.after(pickup);
  }
  function mobileTitle(root) {
    if (root.dataset.vrMobileTitleReady) return;
    const info = root.querySelector('.product__info-container');
    const title = info && info.querySelector('.product__title');
    const media = root.querySelector('.product__media-wrapper');
    if (!title || !media) return;
    root.dataset.vrMobileTitleReady = 'true';
    const originalPlace = document.createComment('VERORARO product title original position');
    title.before(originalPlace);
    const mobile = window.matchMedia('(max-width: 749px)');
    function placeTitle() {
      if (!root.isConnected) { mobile.removeEventListener('change', placeTitle); return; }
      if (mobile.matches) { media.before(title); title.classList.add('vr-mobile-product-title'); }
      else { originalPlace.after(title); title.classList.remove('vr-mobile-product-title'); }
    }
    mobile.addEventListener('change', placeTitle);
    placeTitle();
  }
  function groups(box) {
    if (box.dataset.vrReady) return;
    const wrapper = box.closest('.product__media-wrapper');
    const gallery = wrapper.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    box.dataset.vrReady = 'true';
    const data = JSON.parse(box.querySelector('.vr-gallery-data').textContent);
    const fieldsNode = box.querySelector('.vr-gallery-fields');
    const fields = fieldsNode ? JSON.parse(fieldsNode.textContent) : [[], [], [], []];
    const explicit = fields.map(ids => ids.map(id => data.find(media => String(media.id) === String(id))).filter(Boolean));
    const assigned = new Set(fields.flat().map(String));
    const sets = [[], [], [], []];
    let photoIndex = 0;
    data.forEach(media => {
      let group;
      if (['video', 'external_video'].includes(media.type)) group = 1;
      else if (media.type === 'image') {
        const marker = String(media.alt || '').match(/\[(presentazione|presentation|dettagli|details|difetti|flaws)\]/i);
        group = marker ? (/difetti|flaws/i.test(marker[1]) ? 3 : /dettagli|details/i.test(marker[1]) ? 2 : 0) : (photoIndex < 2 ? 0 : 2);
        photoIndex++;
      }
      media.group = group;
      if (group !== undefined && !assigned.has(String(media.id)) && !explicit[group].length) sets[group].push(media);
    });
    explicit.forEach((items, index) => { if (items.length) sets[index] = items; items.forEach(item => { item.group = index; }); });
    const modal = document.getElementById(box.dataset.modal);
    if (modal) modal.dataset.vrGallery = JSON.stringify(data.map(item => ({id: String(item.id), group: item.group})));
    const buttons = [...box.querySelectorAll('[role="tab"]')];
    const empty = box.querySelector('.vr-gallery-empty');
    buttons.forEach(button => button.setAttribute('aria-controls', gallery.id));
    gallery.setAttribute('role', 'tabpanel');
    function select(button) {
      const set = sets[Number(button.dataset.group)];
      buttons.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      gallery.setAttribute('aria-labelledby', button.id); gallery.hidden = !set.length; empty.hidden = !!set.length;
      const it = document.documentElement.lang.startsWith('it');
      const messages = it ? ['Nessuna foto di presentazione disponibile.', 'Nessun video disponibile.', 'Nessuna foto di dettaglio disponibile.', 'Nessuna foto dei difetti classificata.'] : ['No presentation photos available.', 'No video available.', 'No detail photos available.', 'No flaw photos classified.'];
      empty.textContent = messages[Number(button.dataset.group)];
      if (modal) modal.dataset.vrMediaIds = JSON.stringify(set.map(media => String(media.id)));
      const suffixes = new Set(set.map(media => String(media.id)));
      gallery.querySelectorAll('[data-media-id]').forEach(slide => { slide.hidden = !suffixes.has(slide.dataset.mediaId.split('-').pop()); });
      gallery.querySelectorAll('[data-target]').forEach(thumb => { thumb.hidden = !suffixes.has(thumb.dataset.target.split('-').pop()); });
      if (set.length) { const slide = [...gallery.querySelectorAll('[data-media-id]')].find(item => !item.hidden); gallery.setActiveMedia(slide.dataset.mediaId, false); }
      gallery.querySelectorAll('slider-component').forEach(slider => { if (typeof slider.resetPages === 'function') slider.resetPages(); });
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(button));
      button.addEventListener('keydown', event => {
        const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (delta) { event.preventDefault(); const next = buttons[(index + delta + buttons.length) % buttons.length]; select(next); next.focus(); }
      });
    });
    select(buttons[0]);
  }
  function lightbox(modal) {
    if (modal.dataset.vrReady) return;
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    const allMedia = [...content.children].filter(child => child.hasAttribute('data-media-id'));
    let media = allMedia;
    if (!media.length) return;
    modal.dataset.vrReady = 'true'; modal.classList.add('vr-lightbox', 'vr-progressive-lightbox');
    const it = document.documentElement.lang.startsWith('it');
    const dialog = modal.querySelector('[role="dialog"]');
    const category = document.createElement('div'); category.className = 'vr-lightbox-category'; category.setAttribute('aria-live', 'polite'); dialog.append(category);
    const categoryLabels = it ? ['Presentazione', 'Video', 'Dettagli', 'Difetti'] : ['Presentation', 'Video', 'Details', 'Flaws'];
    function categoryIndex(item) {
      const catalog = modal.dataset.vrGallery ? JSON.parse(modal.dataset.vrGallery) : [];
      return catalog.find(entry => entry.id === item.dataset.mediaId)?.group ?? 0;
    }
    function button(text, label) { const el = document.createElement('button'); el.type = 'button'; el.textContent = text; el.setAttribute('aria-label', label); return el; }
    const nav = document.createElement('div'); nav.className = 'vr-lightbox-nav';
    const prev = button('\u2039', it ? 'Foto precedente' : 'Previous photo');
    const next = button('\u203a', it ? 'Foto successiva' : 'Next photo');
    const count = document.createElement('span'); count.className = 'vr-lightbox-count'; count.setAttribute('aria-live', 'polite');
    nav.append(prev, count, next); dialog.append(nav);
    const controls = document.createElement('div'); controls.className = 'vr-zoom-controls';
    const lens = button('', it ? 'Attiva lente circolare' : 'Activate magnifying lens');
    lens.className = 'vr-zoom-lens'; lens.setAttribute('aria-pressed', 'false');
    lens.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10" cy="10" r="6"/><path d="m15 15 6 6M10 7v6M7 10h6"/></svg>';
    const range = document.createElement('input'); range.type = 'range'; range.min = '100'; range.max = '300'; range.step = '5'; range.value = '100'; range.setAttribute('aria-label', it ? 'Livello di zoom' : 'Zoom level'); range.setAttribute('aria-orientation', 'vertical');
    const level = document.createElement('output'); level.textContent = '1\u00d7';
    const reset = button('1\u00d7', it ? 'Ripristina foto intera' : 'Reset full photo'); reset.className = 'vr-zoom-reset';
    controls.append(lens, range, level, reset); dialog.append(controls);
    const magnifier = document.createElement('div'); magnifier.className = 'vr-detail-lens'; magnifier.hidden = true; magnifier.setAttribute('role', 'presentation'); dialog.append(magnifier);
    function moveLens(clientX, clientY) {
      const img = image(); if (!selecting || !img) { magnifier.hidden = true; return; }
      const rect = img.getBoundingClientRect(); const area = content.getBoundingClientRect();
      if (clientX < Math.max(rect.left, area.left) || clientX > Math.min(rect.right, area.right) || clientY < Math.max(rect.top, area.top) || clientY > Math.min(rect.bottom, area.bottom)) { magnifier.hidden = true; return; }
      const diameter = Math.min(255, Math.max(165, content.clientWidth * .42));
      const power = (Math.max(1, Math.min(3.2, img.naturalWidth / rect.width * 1.25)) * 1.5);
      magnifier.style.width = magnifier.style.height = diameter + 'px';
      magnifier.style.left = clientX + 'px'; magnifier.style.top = clientY + 'px';
      magnifier.style.backgroundImage = 'url("' + img.currentSrc + '")';
      magnifier.style.backgroundSize = (rect.width * power) + 'px ' + (rect.height * power) + 'px';
      magnifier.style.backgroundPosition = (diameter / 2 - (clientX - rect.left) * power) + 'px ' + (diameter / 2 - (clientY - rect.top) * power) + 'px';
      magnifier.hidden = false;
    }
    [nav, controls].forEach(el => el.addEventListener('pointerup', event => event.stopPropagation()));
    let scale = 1, limit = 3, baseW = 0, baseH = 0, offsetX = 0, offsetY = 0, focusX = .5, focusY = .5, selecting = false, drag;
    function activeIndex() { return Math.max(0, media.findIndex(item => item.classList.contains('active'))); }
    function image() { const el = media[activeIndex()]; return el.tagName === 'IMG' ? el : null; }
    function bounds() { return {x: Math.max(0, (baseW * scale - content.clientWidth) / 2), y: Math.max(0, (baseH * scale - content.clientHeight) / 2)}; }
    function paint() {
      const img = image(); if (!img) return;
      const b = bounds(); offsetX = Math.max(-b.x, Math.min(b.x, offsetX)); offsetY = Math.max(-b.y, Math.min(b.y, offsetY));
      img.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
      range.value = String(Math.round(scale * 100)); level.textContent = Number(scale.toFixed(2)) + '\u00d7';
      range.setAttribute('aria-valuetext', level.textContent);
      modal.classList.toggle('vr-zoomed', scale > 1); modal.classList.toggle('vr-select-detail', selecting);
      placeControls();
    }
    function placeControls() {
      const area = content.getBoundingClientRect();
      const item = media[activeIndex()]; if (!item) return;
      const rect = item.getBoundingClientRect();
      const left = Math.max(area.left, rect.left), right = Math.min(area.right, rect.right);
      category.style.left = left + 'px'; category.style.top = Math.max(8, Math.max(area.top, rect.top) - 28) + 'px';
      controls.style.left = Math.max(4, left - 52) + 'px'; controls.style.top = Math.max(area.top, rect.top) + 'px';
      nav.style.left = ((left + right) / 2) + 'px'; nav.style.top = (Math.min(area.bottom, rect.bottom) - 46) + 'px'; nav.style.bottom = 'auto';
    }
    function fit(resetZoom = true) {
      const img = image(); controls.hidden = !img; if (!img || !img.naturalWidth) { placeControls(); return; }
      const small = window.matchMedia('(max-width:749px)').matches;
      const oldWidth = window.innerWidth - (small ? 70 : 128);
      const oldHeight = window.innerHeight - (small ? 196 : 180);
      const factor = Math.min(Math.min(oldWidth / img.naturalWidth, oldHeight / img.naturalHeight, 1) * 1.4, 1);
      baseW = img.naturalWidth * factor; baseH = img.naturalHeight * factor;
      limit = Math.max(1, Math.min(3, 1 / factor)); range.max = String(Math.floor(limit * 100)); range.disabled = limit <= 1; lens.disabled = limit <= 1;
      img.style.width = baseW + 'px'; img.style.height = baseH + 'px';
      if (resetZoom) { magnifier.hidden = true; scale = 1; offsetX = offsetY = 0; focusX = focusY = .5; selecting = false; lens.setAttribute('aria-pressed', 'false'); }
      scale = Math.min(scale, limit); paint();
    }
    function setZoom(value) {
      magnifier.hidden = true; scale = Math.max(1, Math.min(limit, value));
      offsetX = (.5 - focusX) * baseW * scale; offsetY = (.5 - focusY) * baseH * scale; paint();
    }
    let changeRequest = 0, requestedIndex;
    function preparePhoto(img) {
      img.loading = 'eager';
      return img.decode().then(() => img.naturalWidth > 0).catch(() => false);
    }
    function preloadNeighbours() {
      if (media.length < 2 || !image()) return;
      [-1, 1].forEach(delta => {
        const item = media[(activeIndex() + delta + media.length) % media.length];
        if (item.tagName === 'IMG') preparePhoto(item);
      });
    }
    function update() {
      const activeVideo = allMedia.find(item => item.classList.contains('active') && item.tagName !== 'IMG');
      media = activeVideo ? [activeVideo] : allMedia.filter(item => item.tagName === 'IMG').sort((a, b) => categoryIndex(a) - categoryIndex(b));
      nav.hidden = !!activeVideo;
      nav.style.display = activeVideo ? 'none' : 'flex';
      if (!media.length) { controls.hidden = true; count.textContent = '0 / 0'; return; }
      if (!media.some(item => item.classList.contains('active'))) { allMedia.forEach(item => item.classList.toggle('active', item === media[0])); }
      count.textContent = (activeIndex() + 1) + ' / ' + media.length;
      category.textContent = categoryLabels[categoryIndex(media[activeIndex()])]; fit(); preloadNeighbours();
    }
    async function show(delta) {
      if (media.length < 2 || !image()) return;
      const index = ((requestedIndex ?? activeIndex()) + delta + media.length) % media.length;
      requestedIndex = index;
      const request = ++changeRequest, selected = media[index];
      const ready = await preparePhoto(selected);
      if (request !== changeRequest || !modal.hasAttribute('open')) return;
      requestedIndex = undefined;
      if (!ready) return;
      window.pauseAllMedia();
      allMedia.forEach(item => item.classList.toggle('active', item === selected));
      update();
    }
    prev.addEventListener('click', () => show(-1)); next.addEventListener('click', () => show(1));
    range.addEventListener('input', () => setZoom(Number(range.value) / 100));
    reset.addEventListener('click', () => fit());
    lens.addEventListener('click', () => {
      selecting = !selecting; lens.setAttribute('aria-pressed', String(selecting)); paint();
      if (selecting && image()) { const r = image().getBoundingClientRect(); moveLens(r.left + r.width / 2, r.top + r.height / 2); }
      else magnifier.hidden = true;
    });
    content.addEventListener('pointerdown', event => {
      if (!image() || event.button !== 0) return;
      const r = image().getBoundingClientRect();
      if (selecting) {
        moveLens(event.clientX, event.clientY); content.setPointerCapture(event.pointerId); event.preventDefault(); return;
      }
      if (scale > 1 || baseW > content.clientWidth || baseH > content.clientHeight) { drag = {id:event.pointerId, x:event.clientX, y:event.clientY, ox:offsetX, oy:offsetY}; content.setPointerCapture(event.pointerId); event.preventDefault(); }
    });
    content.addEventListener('pointermove', event => {
      if (selecting) { moveLens(event.clientX, event.clientY); return; }
      if (!drag || drag.id !== event.pointerId) return;
      offsetX = drag.ox + event.clientX - drag.x; offsetY = drag.oy + event.clientY - drag.y; paint();
      focusX = .5 - offsetX / (baseW * scale); focusY = .5 - offsetY / (baseH * scale);
    });
    content.addEventListener('pointerup', event => { event.stopPropagation(); drag = undefined; });
    content.addEventListener('pointercancel', () => { drag = undefined; magnifier.hidden = true; });
    content.addEventListener('pointerleave', () => { magnifier.hidden = true; });
    content.addEventListener('wheel', event => { if (!image() || limit <= 1) return; event.preventDefault(); setZoom(scale + (event.deltaY < 0 ? .1 : -.1)); }, {passive:false});
    range.addEventListener('keydown', event => event.stopPropagation());
    modal.addEventListener('keydown', event => { if (event.target === range) return; if (event.key === 'ArrowRight') { event.preventDefault(); show(1); } if (event.key === 'ArrowLeft') { event.preventDefault(); show(-1); } });
    let touchX;
    content.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, {passive:true});
    content.addEventListener('touchend', event => { if (scale === 1 && !selecting && Math.abs(event.changedTouches[0].clientX - touchX) > 60) show(event.changedTouches[0].clientX < touchX ? 1 : -1); }, {passive:true});
    media.filter(item => item.tagName === 'IMG').forEach(img => img.addEventListener('load', () => { if (img === image()) fit(false); }));
    new ResizeObserver(() => { if (modal.hasAttribute('open')) fit(false); }).observe(content);
    new MutationObserver(() => { changeRequest++; requestedIndex = undefined; if (modal.hasAttribute('open')) update(); }).observe(modal, {attributes:true, attributeFilter:['open']});
  }
  function collectionTitle() {
    const title = document.querySelector('.collection-hero__title'); if (!title) return;
    if (!title.dataset.originalTitle) title.dataset.originalTitle = title.textContent.trim().replace(/^(Collezione|Collection):\s*/i, '');
    document.querySelectorAll('.active-facets__button-remove span').forEach(label => { const text = document.documentElement.lang.startsWith('it') ? 'Azzera filtri' : 'Clear filters'; if (label.textContent !== text) label.textContent = text; });
    const filters = new URLSearchParams(location.search).getAll('filter.p.product_type');
    const categoryNames = {Lampade:'Illuminazione', 'Divani e Poltrone':'Salotto', Mobili:'Mobili e storage', Accessori:'Oggetti di design'};
    const categoryLabel = filters.includes('Tavoli') && filters.includes('Sedie') ? 'Tavoli e sedie' : filters.map(value => categoryNames[value] || value).join(' \u00b7 ');
    const selectedTitle = filters.length ? (document.documentElement.lang.startsWith('it') ? 'Prodotti disponibili della nostra collezione ' : 'Available products from our collection ') + categoryLabel : title.dataset.originalTitle;
    if (title.textContent !== selectedTitle) title.textContent = selectedTitle;
    document.querySelectorAll('.active-facets__button').forEach(link => { if (link.href && new URL(link.href).searchParams.getAll('filter.p.product_type').length < filters.length) link.hidden = true; });
  }
  function filterControls() {
    const root = document.querySelector('#main-collection-filters'), title = document.querySelector('.collection-hero__title');
    if (!root || !title || root.dataset.vrObserved) return;
    root.dataset.vrObserved = 'true';
    const it = document.documentElement.lang.startsWith('it');
    const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'vr-filter-toggle';
    toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('aria-controls', 'FacetsWrapperDesktop');
    toggle.textContent = it ? 'Nascondi filtri' : 'Hide filters';
    toggle.addEventListener('click', () => {
      const wrapper = root.querySelector('#FacetsWrapperDesktop'); if (!wrapper) return;
      wrapper.hidden = !wrapper.hidden; toggle.setAttribute('aria-expanded', String(!wrapper.hidden));
      toggle.textContent = wrapper.hidden ? (it ? 'Mostra filtri' : 'Show filters') : (it ? 'Nascondi filtri' : 'Hide filters');
    });
    title.after(toggle);
    let pending;
    new MutationObserver(() => { clearTimeout(pending); pending = setTimeout(() => { const wrapper = root.querySelector('#FacetsWrapperDesktop'); if (wrapper) wrapper.hidden = toggle.getAttribute('aria-expanded') === 'false'; collectionTitle(); }, 50); }).observe(root, {subtree:true, childList:true});
  }
  function init() {
    document.querySelectorAll('.vr-product-details').forEach(root => tabs(root, '.vr-details-panel'));
    document.querySelectorAll('product-info').forEach(purchase);
    document.querySelectorAll('product-info').forEach(mobileTitle);
    document.querySelectorAll('.vr-gallery-groups').forEach(groups);
    document.querySelectorAll('product-modal').forEach(lightbox);
    collectionTitle(); filterControls();
    const header = document.querySelector('.section-header'); if (header && !header.dataset.vrObserved) { header.dataset.vrObserved = 'true'; new ResizeObserver(() => document.documentElement.style.setProperty('--vr-header-height', header.offsetHeight + 'px')).observe(header); }
  }
  document.addEventListener('DOMContentLoaded', init, {once:true});
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('popstate', collectionTitle);
  document.addEventListener('change', event => { if (event.target.closest('facet-filters-form')) setTimeout(collectionTitle, 700); });
  if (document.readyState !== 'loading') init();
})();
